import locales from 'src/i18n/locales/en.json';
import { Language } from 'src/shared/enum/Countries';

import { UserData } from './types';

export const userDataKeys: { [K in keyof UserData]: K } = {
    firstName: 'firstName',
    lastName: 'lastName',
    preferredName: 'preferredName',
    password: 'password',
    repeatPassword: 'repeatPassword',
    email: 'email',
    phone: 'phone',
    dateOfBirth: 'dateOfBirth',
    address1: 'address1',
    address2: 'address2',
    city: 'city',
    postCode: 'postCode',
    country: 'country',
    nationality: 'nationality',
    preferredLanguage: 'preferredLanguage',
    university: 'university',
    studyYear: 'studyYear',
    isSpanishResident: 'isSpanishResident',
    nifNumber: 'nifNumber',
    nieNumber: 'nieNumber',
    passportNumber: 'passportNumber',
    passportIssuingCountry: 'passportIssuingCountry',
    userFormConfirmation: 'userFormConfirmation',
};

export const defaultOption = {
    value: locales.dropdown_default_option,
    label: 'dropdown_default_option',
};

export const nationalities = [
    { value: locales.nationalities_afghan, label: 'nationalities_afghan' },
    { value: locales.nationalities_albanian, label: 'nationalities_albanian' },
    { value: locales.nationalities_algerian, label: 'nationalities_algerian' },
    { value: locales.nationalities_american, label: 'nationalities_american' },
    { value: locales.nationalities_andorran, label: 'nationalities_andorran' },
    { value: locales.nationalities_angolan, label: 'nationalities_angolan' },
    { value: locales.nationalities_anguillan, label: 'nationalities_anguillan' },
    { value: locales.nationalities_argentine, label: 'nationalities_argentine' },
    { value: locales.nationalities_armenian, label: 'nationalities_armenian' },
    { value: locales.nationalities_australian, label: 'nationalities_australian' },
    { value: locales.nationalities_austrian, label: 'nationalities_austrian' },
    { value: locales.nationalities_azerbaijani, label: 'nationalities_azerbaijani' },
    { value: locales.nationalities_bahamian, label: 'nationalities_bahamian' },
    { value: locales.nationalities_bahraini, label: 'nationalities_bahraini' },
    { value: locales.nationalities_bangladeshi, label: 'nationalities_bangladeshi' },
    { value: locales.nationalities_barbadian, label: 'nationalities_barbadian' },
    { value: locales.nationalities_belarusian, label: 'nationalities_belarusian' },
    { value: locales.nationalities_belgian, label: 'nationalities_belgian' },
    { value: locales.nationalities_belizean, label: 'nationalities_belizean' },
    { value: locales.nationalities_beninese, label: 'nationalities_beninese' },
    { value: locales.nationalities_bermudian, label: 'nationalities_bermudian' },
    { value: locales.nationalities_bhutanese, label: 'nationalities_bhutanese' },
    { value: locales.nationalities_bolivian, label: 'nationalities_bolivian' },
    { value: locales.nationalities_botswanan, label: 'nationalities_botswanan' },
    { value: locales.nationalities_brazilian, label: 'nationalities_brazilian' },
    { value: locales.nationalities_british, label: 'nationalities_british' },
    {
        value: locales.nationalities_british_virgin_islander,
        label: 'nationalities_british_virgin_islander',
    },
    { value: locales.nationalities_bruneian, label: 'nationalities_bruneian' },
    { value: locales.nationalities_bulgarian, label: 'nationalities_bulgarian' },
    { value: locales.nationalities_burkinan, label: 'nationalities_burkinan' },
    { value: locales.nationalities_burmese, label: 'nationalities_burmese' },
    { value: locales.nationalities_burundian, label: 'nationalities_burundian' },
    { value: locales.nationalities_cambodian, label: 'nationalities_cambodian' },
    { value: locales.nationalities_cameroonian, label: 'nationalities_cameroonian' },
    { value: locales.nationalities_canadian, label: 'nationalities_canadian' },
    { value: locales.nationalities_cape_verdean, label: 'nationalities_cape_verdean' },
    { value: locales.nationalities_cayman_islander, label: 'nationalities_cayman_islander' },
    { value: locales.nationalities_central_african, label: 'nationalities_central_african' },
    { value: locales.nationalities_chadian, label: 'nationalities_chadian' },
    { value: locales.nationalities_chilean, label: 'nationalities_chilean' },
    { value: locales.nationalities_chinese, label: 'nationalities_chinese' },
    {
        value: locales.nationalities_citizen_of_antigua_and_barbuda,
        label: 'nationalities_citizen_of_antigua_and_barbuda',
    },
    {
        value: locales.nationalities_citizen_of_bosnia_and_herzegovina,
        label: 'nationalities_citizen_of_bosnia_and_herzegovina',
    },
    {
        value: locales.nationalities_citizen_of_guinea_bissau,
        label: 'nationalities_citizen_of_guinea_bissau',
    },
    {
        value: locales.nationalities_citizen_of_kiribati,
        label: 'nationalities_citizen_of_kiribati',
    },
    {
        value: locales.nationalities_citizen_of_seychelles,
        label: 'nationalities_citizen_of_seychelles',
    },
    {
        value: locales.nationalities_citizen_of_the_dominican_republic,
        label: 'nationalities_citizen_of_the_dominican_republic',
    },
    { value: locales.nationalities_citizen_of_vanuatu, label: 'nationalities_citizen_of_vanuatu' },
    { value: locales.nationalities_colombian, label: 'nationalities_colombian' },
    { value: locales.nationalities_comoran, label: 'nationalities_comoran' },
    { value: locales.nationalities_congolese_congo, label: 'nationalities_congolese_congo' },
    { value: locales.nationalities_congolese_drc, label: 'nationalities_congolese_drc' },
    { value: locales.nationalities_cook_islander, label: 'nationalities_cook_islander' },
    { value: locales.nationalities_costa_rican, label: 'nationalities_costa_rican' },
    { value: locales.nationalities_croatian, label: 'nationalities_croatian' },
    { value: locales.nationalities_cuban, label: 'nationalities_cuban' },
    { value: locales.nationalities_cymraes, label: 'nationalities_cymraes' },
    { value: locales.nationalities_cymro, label: 'nationalities_cymro' },
    { value: locales.nationalities_cypriot, label: 'nationalities_cypriot' },
    { value: locales.nationalities_czech, label: 'nationalities_czech' },
    { value: locales.nationalities_danish, label: 'nationalities_danish' },
    { value: locales.nationalities_djiboutian, label: 'nationalities_djiboutian' },
    { value: locales.nationalities_dominican, label: 'nationalities_dominican' },
    { value: locales.nationalities_dutch, label: 'nationalities_dutch' },
    { value: locales.nationalities_east_timorese, label: 'nationalities_east_timorese' },
    { value: locales.nationalities_ecuadorean, label: 'nationalities_ecuadorean' },
    { value: locales.nationalities_egyptian, label: 'nationalities_egyptian' },
    { value: locales.nationalities_emirati, label: 'nationalities_emirati' },
    { value: locales.nationalities_english, label: 'nationalities_english' },
    { value: locales.nationalities_equatorial_guinean, label: 'nationalities_equatorial_guinean' },
    { value: locales.nationalities_eritrean, label: 'nationalities_eritrean' },
    { value: locales.nationalities_estonian, label: 'nationalities_estonian' },
    { value: locales.nationalities_ethiopian, label: 'nationalities_ethiopian' },
    { value: locales.nationalities_faroese, label: 'nationalities_faroese' },
    { value: locales.nationalities_fijian, label: 'nationalities_fijian' },
    { value: locales.nationalities_filipino, label: 'nationalities_filipino' },
    { value: locales.nationalities_finnish, label: 'nationalities_finnish' },
    { value: locales.nationalities_french, label: 'nationalities_french' },
    { value: locales.nationalities_gabonese, label: 'nationalities_gabonese' },
    { value: locales.nationalities_gambian, label: 'nationalities_gambian' },
    { value: locales.nationalities_georgian, label: 'nationalities_georgian' },
    { value: locales.nationalities_german, label: 'nationalities_german' },
    { value: locales.nationalities_ghanaian, label: 'nationalities_ghanaian' },
    { value: locales.nationalities_gibraltarian, label: 'nationalities_gibraltarian' },
    { value: locales.nationalities_greek, label: 'nationalities_greek' },
    { value: locales.nationalities_greenlandic, label: 'nationalities_greenlandic' },
    { value: locales.nationalities_grenadian, label: 'nationalities_grenadian' },
    { value: locales.nationalities_guamanian, label: 'nationalities_guamanian' },
    { value: locales.nationalities_guatemalan, label: 'nationalities_guatemalan' },
    { value: locales.nationalities_guinean, label: 'nationalities_guinean' },
    { value: locales.nationalities_guyanese, label: 'nationalities_guyanese' },
    { value: locales.nationalities_haitian, label: 'nationalities_haitian' },
    { value: locales.nationalities_honduran, label: 'nationalities_honduran' },
    { value: locales.nationalities_hong_konger, label: 'nationalities_hong_konger' },
    { value: locales.nationalities_hungarian, label: 'nationalities_hungarian' },
    { value: locales.nationalities_icelandic, label: 'nationalities_icelandic' },
    { value: locales.nationalities_indian, label: 'nationalities_indian' },
    { value: locales.nationalities_indonesian, label: 'nationalities_indonesian' },
    { value: locales.nationalities_iranian, label: 'nationalities_iranian' },
    { value: locales.nationalities_iraqi, label: 'nationalities_iraqi' },
    { value: locales.nationalities_irish, label: 'nationalities_irish' },
    { value: locales.nationalities_israeli, label: 'nationalities_israeli' },
    { value: locales.nationalities_italian, label: 'nationalities_italian' },
    { value: locales.nationalities_ivorian, label: 'nationalities_ivorian' },
    { value: locales.nationalities_jamaican, label: 'nationalities_jamaican' },
    { value: locales.nationalities_japanese, label: 'nationalities_japanese' },
    { value: locales.nationalities_jordanian, label: 'nationalities_jordanian' },
    { value: locales.nationalities_kazakh, label: 'nationalities_kazakh' },
    { value: locales.nationalities_kenyan, label: 'nationalities_kenyan' },
    { value: locales.nationalities_kittitian, label: 'nationalities_kittitian' },
    { value: locales.nationalities_kosovan, label: 'nationalities_kosovan' },
    { value: locales.nationalities_kuwaiti, label: 'nationalities_kuwaiti' },
    { value: locales.nationalities_kyrgyz, label: 'nationalities_kyrgyz' },
    { value: locales.nationalities_lao, label: 'nationalities_lao' },
    { value: locales.nationalities_latvian, label: 'nationalities_latvian' },
    { value: locales.nationalities_lebanese, label: 'nationalities_lebanese' },
    { value: locales.nationalities_liberian, label: 'nationalities_liberian' },
    { value: locales.nationalities_libyan, label: 'nationalities_libyan' },
    {
        value: locales.nationalities_liechtenstein_citizen,
        label: 'nationalities_liechtenstein_citizen',
    },
    { value: locales.nationalities_lithuanian, label: 'nationalities_lithuanian' },
    { value: locales.nationalities_luxembourger, label: 'nationalities_luxembourger' },
    { value: locales.nationalities_macanese, label: 'nationalities_macanese' },
    { value: locales.nationalities_macedonian, label: 'nationalities_macedonian' },
    { value: locales.nationalities_malagasy, label: 'nationalities_malagasy' },
    { value: locales.nationalities_malawian, label: 'nationalities_malawian' },
    { value: locales.nationalities_malaysian, label: 'nationalities_malaysian' },
    { value: locales.nationalities_maldivian, label: 'nationalities_maldivian' },
    { value: locales.nationalities_malian, label: 'nationalities_malian' },
    { value: locales.nationalities_maltese, label: 'nationalities_maltese' },
    { value: locales.nationalities_marshallese, label: 'nationalities_marshallese' },
    { value: locales.nationalities_martiniquais, label: 'nationalities_martiniquais' },
    { value: locales.nationalities_mauritanian, label: 'nationalities_mauritanian' },
    { value: locales.nationalities_mauritian, label: 'nationalities_mauritian' },
    { value: locales.nationalities_mexican, label: 'nationalities_mexican' },
    { value: locales.nationalities_micronesian, label: 'nationalities_micronesian' },
    { value: locales.nationalities_moldovan, label: 'nationalities_moldovan' },
    { value: locales.nationalities_monegasque, label: 'nationalities_monegasque' },
    { value: locales.nationalities_mongolian, label: 'nationalities_mongolian' },
    { value: locales.nationalities_montenegrin, label: 'nationalities_montenegrin' },
    { value: locales.nationalities_montserratian, label: 'nationalities_montserratian' },
    { value: locales.nationalities_moroccan, label: 'nationalities_moroccan' },
    { value: locales.nationalities_mosotho, label: 'nationalities_mosotho' },
    { value: locales.nationalities_mozambican, label: 'nationalities_mozambican' },
    { value: locales.nationalities_namibian, label: 'nationalities_namibian' },
    { value: locales.nationalities_nauruan, label: 'nationalities_nauruan' },
    { value: locales.nationalities_nepalese, label: 'nationalities_nepalese' },
    { value: locales.nationalities_new_zealander, label: 'nationalities_new_zealander' },
    { value: locales.nationalities_nicaraguan, label: 'nationalities_nicaraguan' },
    { value: locales.nationalities_nigerian, label: 'nationalities_nigerian' },
    { value: locales.nationalities_nigerien, label: 'nationalities_nigerien' },
    { value: locales.nationalities_niuean, label: 'nationalities_niuean' },
    { value: locales.nationalities_north_korean, label: 'nationalities_north_korean' },
    { value: locales.nationalities_northern_irish, label: 'nationalities_northern_irish' },
    { value: locales.nationalities_norwegian, label: 'nationalities_norwegian' },
    { value: locales.nationalities_omani, label: 'nationalities_omani' },
    { value: locales.nationalities_other, label: 'nationalities_other' },
    { value: locales.nationalities_pakistani, label: 'nationalities_pakistani' },
    { value: locales.nationalities_palauan, label: 'nationalities_palauan' },
    { value: locales.nationalities_palestinian, label: 'nationalities_palestinian' },
    { value: locales.nationalities_panamanian, label: 'nationalities_panamanian' },
    { value: locales.nationalities_papua_new_guinean, label: 'nationalities_papua_new_guinean' },
    { value: locales.nationalities_paraguayan, label: 'nationalities_paraguayan' },
    { value: locales.nationalities_peruvian, label: 'nationalities_peruvian' },
    { value: locales.nationalities_polish, label: 'nationalities_polish' },
    { value: locales.nationalities_portuguese, label: 'nationalities_portuguese' },
    { value: locales.nationalities_prydeinig, label: 'nationalities_prydeinig' },
    { value: locales.nationalities_puerto_rican, label: 'nationalities_puerto_rican' },
    { value: locales.nationalities_qatari, label: 'nationalities_qatari' },
    { value: locales.nationalities_romanian, label: 'nationalities_romanian' },
    { value: locales.nationalities_russian, label: 'nationalities_russian' },
    { value: locales.nationalities_rwandan, label: 'nationalities_rwandan' },
    { value: locales.nationalities_salvadorean, label: 'nationalities_salvadorean' },
    { value: locales.nationalities_sammarinese, label: 'nationalities_sammarinese' },
    { value: locales.nationalities_samoan, label: 'nationalities_samoan' },
    { value: locales.nationalities_sao_tomean, label: 'nationalities_sao_tomean' },
    { value: locales.nationalities_saudi_arabian, label: 'nationalities_saudi_arabian' },
    { value: locales.nationalities_scottish, label: 'nationalities_scottish' },
    { value: locales.nationalities_senegalese, label: 'nationalities_senegalese' },
    { value: locales.nationalities_serbian, label: 'nationalities_serbian' },
    { value: locales.nationalities_sierra_leonean, label: 'nationalities_sierra_leonean' },
    { value: locales.nationalities_singaporean, label: 'nationalities_singaporean' },
    { value: locales.nationalities_slovak, label: 'nationalities_slovak' },
    { value: locales.nationalities_slovenian, label: 'nationalities_slovenian' },
    { value: locales.nationalities_solomon_islander, label: 'nationalities_solomon_islander' },
    { value: locales.nationalities_somali, label: 'nationalities_somali' },
    { value: locales.nationalities_south_african, label: 'nationalities_south_african' },
    { value: locales.nationalities_south_korean, label: 'nationalities_south_korean' },
    { value: locales.nationalities_south_sudanese, label: 'nationalities_south_sudanese' },
    { value: locales.nationalities_spanish, label: 'nationalities_spanish' },
    { value: locales.nationalities_sri_lankan, label: 'nationalities_sri_lankan' },
    { value: locales.nationalities_st_helenian, label: 'nationalities_st_helenian' },
    { value: locales.nationalities_st_lucian, label: 'nationalities_st_lucian' },
    { value: locales.nationalities_stateless, label: 'nationalities_stateless' },
    { value: locales.nationalities_sudanese, label: 'nationalities_sudanese' },
    { value: locales.nationalities_surinamese, label: 'nationalities_surinamese' },
    { value: locales.nationalities_swazi, label: 'nationalities_swazi' },
    { value: locales.nationalities_swiss, label: 'nationalities_swiss' },
    { value: locales.nationalities_syrian, label: 'nationalities_syrian' },
    { value: locales.nationalities_taiwanese, label: 'nationalities_taiwanese' },
    { value: locales.nationalities_tajik, label: 'nationalities_tajik' },
    { value: locales.nationalities_tanzanian, label: 'nationalities_tanzanian' },
    { value: locales.nationalities_thai, label: 'nationalities_thai' },
    { value: locales.nationalities_togolese, label: 'nationalities_togolese' },
    { value: locales.nationalities_tongan, label: 'nationalities_tongan' },
    { value: locales.nationalities_trinidadian, label: 'nationalities_trinidadian' },
    { value: locales.nationalities_tunisian, label: 'nationalities_tunisian' },
    { value: locales.nationalities_turkish, label: 'nationalities_turkish' },
    { value: locales.nationalities_turkmen, label: 'nationalities_turkmen' },
    { value: locales.nationalities_tuvaluan, label: 'nationalities_tuvaluan' },
    { value: locales.nationalities_ugandan, label: 'nationalities_ugandan' },
    { value: locales.nationalities_ukrainian, label: 'nationalities_ukrainian' },
    { value: locales.nationalities_uruguayan, label: 'nationalities_uruguayan' },
    { value: locales.nationalities_uzbek, label: 'nationalities_uzbek' },
    { value: locales.nationalities_vatican_citizen, label: 'nationalities_vatican_citizen' },
    { value: locales.nationalities_venezuelan, label: 'nationalities_venezuelan' },
    { value: locales.nationalities_vietnamese, label: 'nationalities_vietnamese' },
    { value: locales.nationalities_vincentian, label: 'nationalities_vincentian' },
    { value: locales.nationalities_wallisian, label: 'nationalities_wallisian' },
    { value: locales.nationalities_yemeni, label: 'nationalities_yemeni' },
    { value: locales.nationalities_zambian, label: 'nationalities_zambian' },
    { value: locales.nationalities_zimbabwean, label: 'nationalities_zimbabwean' },
];

export const countries = [
    { value: locales.countries_afghanistan, label: 'countries_afghanistan' },
    { value: locales.countries_albania, label: 'countries_albania' },
    { value: locales.countries_algeria, label: 'countries_algeria' },
    { value: locales.countries_andorra, label: 'countries_andorra' },
    { value: locales.countries_angola, label: 'countries_angola' },
    { value: locales.countries_antigua_deps, label: 'countries_antigua_deps' },
    { value: locales.countries_argentina, label: 'countries_argentina' },
    { value: locales.countries_armenia, label: 'countries_armenia' },
    { value: locales.countries_australia, label: 'countries_australia' },
    { value: locales.countries_austria, label: 'countries_austria' },
    { value: locales.countries_azerbaijan, label: 'countries_azerbaijan' },
    { value: locales.countries_bahamas, label: 'countries_bahamas' },
    { value: locales.countries_bahrain, label: 'countries_bahrain' },
    { value: locales.countries_bangladesh, label: 'countries_bangladesh' },
    { value: locales.countries_barbados, label: 'countries_barbados' },
    { value: locales.countries_belarus, label: 'countries_belarus' },
    { value: locales.countries_belgium, label: 'countries_belgium' },
    { value: locales.countries_belize, label: 'countries_belize' },
    { value: locales.countries_benin, label: 'countries_benin' },
    { value: locales.countries_bhutan, label: 'countries_bhutan' },
    { value: locales.countries_bolivia, label: 'countries_bolivia' },
    { value: locales.countries_bosnia_herzegovina, label: 'countries_bosnia_herzegovina' },
    { value: locales.countries_botswana, label: 'countries_botswana' },
    { value: locales.countries_brazil, label: 'countries_brazil' },
    { value: locales.countries_brunei, label: 'countries_brunei' },
    { value: locales.countries_bulgaria, label: 'countries_bulgaria' },
    { value: locales.countries_burkina, label: 'countries_burkina' },
    { value: locales.countries_burundi, label: 'countries_burundi' },
    { value: locales.countries_cambodia, label: 'countries_cambodia' },
    { value: locales.countries_cameroon, label: 'countries_cameroon' },
    { value: locales.countries_canada, label: 'countries_canada' },
    { value: locales.countries_cape_verde, label: 'countries_cape_verde' },
    { value: locales.countries_central_african_rep, label: 'countries_central_african_rep' },
    { value: locales.countries_chad, label: 'countries_chad' },
    { value: locales.countries_chile, label: 'countries_chile' },
    { value: locales.countries_china, label: 'countries_china' },
    { value: locales.countries_colombia, label: 'countries_colombia' },
    { value: locales.countries_comoros, label: 'countries_comoros' },
    { value: locales.countries_congo, label: 'countries_congo' },
    { value: locales.countries_congo_democratic_rep, label: 'countries_congo_democratic_rep' },
    { value: locales.countries_costa_rica, label: 'countries_costa_rica' },
    { value: locales.countries_croatia, label: 'countries_croatia' },
    { value: locales.countries_cuba, label: 'countries_cuba' },
    { value: locales.countries_cyprus, label: 'countries_cyprus' },
    { value: locales.countries_czech_republic, label: 'countries_czech_republic' },
    { value: locales.countries_denmark, label: 'countries_denmark' },
    { value: locales.countries_djibouti, label: 'countries_djibouti' },
    { value: locales.countries_dominica, label: 'countries_dominica' },
    { value: locales.countries_dominican_republic, label: 'countries_dominican_republic' },
    { value: locales.countries_east_timor, label: 'countries_east_timor' },
    { value: locales.countries_ecuador, label: 'countries_ecuador' },
    { value: locales.countries_egypt, label: 'countries_egypt' },
    { value: locales.countries_el_salvador, label: 'countries_el_salvador' },
    { value: locales.countries_equatorial_guinea, label: 'countries_equatorial_guinea' },
    { value: locales.countries_eritrea, label: 'countries_eritrea' },
    { value: locales.countries_estonia, label: 'countries_estonia' },
    { value: locales.countries_ethiopia, label: 'countries_ethiopia' },
    { value: locales.countries_fiji, label: 'countries_fiji' },
    { value: locales.countries_finland, label: 'countries_finland' },
    { value: locales.countries_france, label: 'countries_france' },
    { value: locales.countries_gabon, label: 'countries_gabon' },
    { value: locales.countries_gambia, label: 'countries_gambia' },
    { value: locales.countries_georgia, label: 'countries_georgia' },
    { value: locales.countries_germany, label: 'countries_germany' },
    { value: locales.countries_ghana, label: 'countries_ghana' },
    { value: locales.countries_greece, label: 'countries_greece' },
    { value: locales.countries_grenada, label: 'countries_grenada' },
    { value: locales.countries_guatemala, label: 'countries_guatemala' },
    { value: locales.countries_guinea, label: 'countries_guinea' },
    { value: locales.countries_guinea_bissau, label: 'countries_guinea_bissau' },
    { value: locales.countries_guyana, label: 'countries_guyana' },
    { value: locales.countries_haiti, label: 'countries_haiti' },
    { value: locales.countries_honduras, label: 'countries_honduras' },
    { value: locales.countries_hong_kong, label: 'countries_hong_kong' },
    { value: locales.countries_hungary, label: 'countries_hungary' },
    { value: locales.countries_iceland, label: 'countries_iceland' },
    { value: locales.countries_india, label: 'countries_india' },
    { value: locales.countries_indonesia, label: 'countries_indonesia' },
    { value: locales.countries_iran, label: 'countries_iran' },
    { value: locales.countries_iraq, label: 'countries_iraq' },
    { value: locales.countries_ireland_republic, label: 'countries_ireland_republic' },
    { value: locales.countries_israel, label: 'countries_israel' },
    { value: locales.countries_italy, label: 'countries_italy' },
    { value: locales.countries_ivory_coast, label: 'countries_ivory_coast' },
    { value: locales.countries_jamaica, label: 'countries_jamaica' },
    { value: locales.countries_japan, label: 'countries_japan' },
    { value: locales.countries_jordan, label: 'countries_jordan' },
    { value: locales.countries_kazakhstan, label: 'countries_kazakhstan' },
    { value: locales.countries_kenya, label: 'countries_kenya' },
    { value: locales.countries_kiribati, label: 'countries_kiribati' },
    { value: locales.countries_korea_north, label: 'countries_korea_north' },
    { value: locales.countries_korea_south, label: 'countries_korea_south' },
    { value: locales.countries_kosovo, label: 'countries_kosovo' },
    { value: locales.countries_kuwait, label: 'countries_kuwait' },
    { value: locales.countries_kyrgyzstan, label: 'countries_kyrgyzstan' },
    { value: locales.countries_laos, label: 'countries_laos' },
    { value: locales.countries_latvia, label: 'countries_latvia' },
    { value: locales.countries_lebanon, label: 'countries_lebanon' },
    { value: locales.countries_lesotho, label: 'countries_lesotho' },
    { value: locales.countries_liberia, label: 'countries_liberia' },
    { value: locales.countries_libya, label: 'countries_libya' },
    { value: locales.countries_liechtenstein, label: 'countries_liechtenstein' },
    { value: locales.countries_lithuania, label: 'countries_lithuania' },
    { value: locales.countries_luxembourg, label: 'countries_luxembourg' },
    { value: locales.countries_macedonia, label: 'countries_macedonia' },
    { value: locales.countries_madagascar, label: 'countries_madagascar' },
    { value: locales.countries_malawi, label: 'countries_malawi' },
    { value: locales.countries_malaysia, label: 'countries_malaysia' },
    { value: locales.countries_maldives, label: 'countries_maldives' },
    { value: locales.countries_mali, label: 'countries_mali' },
    { value: locales.countries_malta, label: 'countries_malta' },
    { value: locales.countries_marshall_islands, label: 'countries_marshall_islands' },
    { value: locales.countries_mauritania, label: 'countries_mauritania' },
    { value: locales.countries_mauritius, label: 'countries_mauritius' },
    { value: locales.countries_mexico, label: 'countries_mexico' },
    { value: locales.countries_micronesia, label: 'countries_micronesia' },
    { value: locales.countries_moldova, label: 'countries_moldova' },
    { value: locales.countries_monaco, label: 'countries_monaco' },
    { value: locales.countries_mongolia, label: 'countries_mongolia' },
    { value: locales.countries_montenegro, label: 'countries_montenegro' },
    { value: locales.countries_morocco, label: 'countries_morocco' },
    { value: locales.countries_mozambique, label: 'countries_mozambique' },
    { value: locales.countries_myanmar_burma, label: 'countries_myanmar_burma' },
    { value: locales.countries_namibia, label: 'countries_namibia' },
    { value: locales.countries_nauru, label: 'countries_nauru' },
    { value: locales.countries_nepal, label: 'countries_nepal' },
    { value: locales.countries_netherlands, label: 'countries_netherlands' },
    { value: locales.countries_new_zealand, label: 'countries_new_zealand' },
    { value: locales.countries_nicaragua, label: 'countries_nicaragua' },
    { value: locales.countries_niger, label: 'countries_niger' },
    { value: locales.countries_nigeria, label: 'countries_nigeria' },
    { value: locales.countries_norway, label: 'countries_norway' },
    { value: locales.countries_oman, label: 'countries_oman' },
    { value: locales.countries_other, label: 'countries_other' },
    { value: locales.countries_pakistan, label: 'countries_pakistan' },
    { value: locales.countries_palau, label: 'countries_palau' },
    { value: locales.countries_panama, label: 'countries_panama' },
    { value: locales.countries_papua_new_guinea, label: 'countries_papua_new_guinea' },
    { value: locales.countries_paraguay, label: 'countries_paraguay' },
    { value: locales.countries_peru, label: 'countries_peru' },
    { value: locales.countries_philippines, label: 'countries_philippines' },
    { value: locales.countries_poland, label: 'countries_poland' },
    { value: locales.countries_portugal, label: 'countries_portugal' },
    { value: locales.countries_qatar, label: 'countries_qatar' },
    { value: locales.countries_romania, label: 'countries_romania' },
    { value: locales.countries_russian_federation, label: 'countries_russian_federation' },
    { value: locales.countries_rwanda, label: 'countries_rwanda' },
    { value: locales.countries_st_kitts_nevis, label: 'countries_st_kitts_nevis' },
    { value: locales.countries_st_lucia, label: 'countries_st_lucia' },
    {
        value: locales.countries_saint_vincent_the_grenadines,
        label: 'countries_saint_vincent_the_grenadines',
    },
    { value: locales.countries_samoa, label: 'countries_samoa' },
    { value: locales.countries_san_marino, label: 'countries_san_marino' },
    { value: locales.countries_sao_tome_principe, label: 'countries_sao_tome_principe' },
    { value: locales.countries_saudi_arabia, label: 'countries_saudi_arabia' },
    { value: locales.countries_senegal, label: 'countries_senegal' },
    { value: locales.countries_serbia, label: 'countries_serbia' },
    { value: locales.countries_seychelles, label: 'countries_seychelles' },
    { value: locales.countries_sierra_leone, label: 'countries_sierra_leone' },
    { value: locales.countries_singapore, label: 'countries_singapore' },
    { value: locales.countries_slovakia, label: 'countries_slovakia' },
    { value: locales.countries_slovenia, label: 'countries_slovenia' },
    { value: locales.countries_solomon_islands, label: 'countries_solomon_islands' },
    { value: locales.countries_somalia, label: 'countries_somalia' },
    { value: locales.countries_south_africa, label: 'countries_south_africa' },
    { value: locales.countries_south_sudan, label: 'countries_south_sudan' },
    { value: locales.countries_spain, label: 'countries_spain' },
    { value: locales.countries_sri_lanka, label: 'countries_sri_lanka' },
    { value: locales.countries_sudan, label: 'countries_sudan' },
    { value: locales.countries_suriname, label: 'countries_suriname' },
    { value: locales.countries_swaziland, label: 'countries_swaziland' },
    { value: locales.countries_sweden, label: 'countries_sweden' },
    { value: locales.countries_switzerland, label: 'countries_switzerland' },
    { value: locales.countries_syria, label: 'countries_syria' },
    { value: locales.countries_taiwan, label: 'countries_taiwan' },
    { value: locales.countries_tajikistan, label: 'countries_tajikistan' },
    { value: locales.countries_tanzania, label: 'countries_tanzania' },
    { value: locales.countries_thailand, label: 'countries_thailand' },
    { value: locales.countries_togo, label: 'countries_togo' },
    { value: locales.countries_tonga, label: 'countries_tonga' },
    { value: locales.countries_trinidad_tobago, label: 'countries_trinidad_tobago' },
    { value: locales.countries_tunisia, label: 'countries_tunisia' },
    { value: locales.countries_turkey, label: 'countries_turkey' },
    { value: locales.countries_turkmenistan, label: 'countries_turkmenistan' },
    { value: locales.countries_tuvalu, label: 'countries_tuvalu' },
    { value: locales.countries_uganda, label: 'countries_uganda' },
    { value: locales.countries_ukraine, label: 'countries_ukraine' },
    { value: locales.countries_united_arab_emirates, label: 'countries_united_arab_emirates' },
    { value: locales.countries_united_kingdom, label: 'countries_united_kingdom' },
    { value: locales.countries_united_states, label: 'countries_united_states' },
    { value: locales.countries_uruguay, label: 'countries_uruguay' },
    { value: locales.countries_uzbekistan, label: 'countries_uzbekistan' },
    { value: locales.countries_vanuatu, label: 'countries_vanuatu' },
    { value: locales.countries_vatican_city, label: 'countries_vatican_city' },
    { value: locales.countries_venezuela, label: 'countries_venezuela' },
    { value: locales.countries_vietnam, label: 'countries_vietnam' },
    { value: locales.countries_yemen, label: 'countries_yemen' },
    { value: locales.countries_zambia, label: 'countries_zambia' },
    { value: locales.countries_zimbabwe, label: 'countries_zimbabwe' },
];

export const studyYears = [
    defaultOption,
    { value: locales.study_years_undergraduate1, label: 'study_years_undergraduate1' },
    { value: locales.study_years_undergraduate2, label: 'study_years_undergraduate2' },
    { value: locales.study_years_undergraduate3, label: 'study_years_undergraduate3' },
    { value: locales.study_years_undergraduate4, label: 'study_years_undergraduate4' },
    { value: locales.study_years_foundation, label: 'study_years_foundation' },
    { value: locales.study_years_postgrad, label: 'study_years_postgrad' },
    { value: locales.study_years_masters, label: 'study_years_masters' },
    { value: locales.study_years_phd, label: 'study_years_phd' },
    { value: locales.study_years_other, label: 'study_years_other' },
];

export const languages = [
    defaultOption,
    { value: Language.EN, label: 'language_english' },
    { value: Language.ES, label: 'language_spanish' },
];

const universitiesEn = [
    'Aberystwyth University',
    'Anglia Ruskin University',
    'Aston University',
    'Bangor University',
    'Bath Spa University',
    'Birkbeck College',
    'Birmingham City University',
    'Bishop Grosseteste University',
    'Bournemouth University',
    'Brunel University London',
    'Buckinghamshire New University',
    'Canterbury Christ Church University',
    'Cardiff Metropolitan University',
    'Cardiff University',
    'Conservatoire for Dance and Drama',
    'Courtauld Institute of Art',
    'Coventry University',
    'Cranfield University',
    'De Montfort University',
    'Edge Hill University',
    'Edinburgh Napier University',
    'Falmouth University',
    'Glasgow Caledonian University',
    'Glasgow School of Art',
    'Glyndŵr University',
    'Goldsmiths College',
    'Guildhall School of Music and Drama',
    'Harper Adams University',
    'Heriot-Watt University',
    'Heythrop College',
    'Imperial College of Science, Technology and Medicine',
    'Institute of Education',
    "King's College London",
    'Kingston University',
    'Leeds Beckett University',
    'Leeds College of Art',
    'Leeds Trinity University',
    'Liverpool Hope University',
    'Liverpool John Moores University',
    'Liverpool School of Tropical Medicine',
    'London Business School',
    'London Metropolitan University',
    'London School of Economics and Political Science',
    'London School of Hygiene and Tropical Medicine',
    'London South Bank University',
    'Loughborough University',
    'Middlesex University',
    'Newman University',
    'Norwich University of the Arts',
    'Other',
    'Oxford Brookes University',
    'Plymouth College of Art',
    'Queen Margaret University, Edinburgh',
    'Queen Mary University of London',
    'Ravensbourne',
    'Roehampton University',
    'Rose Bruford College',
    'Royal Academy of Music',
    'Royal Agricultural University',
    'Royal College of Art',
    'Royal College of Music',
    'Royal Conservatoire of Scotland',
    'Royal Holloway and Bedford New College',
    'Royal Northern College of Music',
    'SRUC',
    'Sheffield Hallam University',
    'Southampton Solent University',
    "St George's Hospital Medical School",
    "St Mary's University College",
    "St Mary's University, Twickenham",
    'Staffordshire University',
    'Stranmillis University College',
    'Swansea University',
    'Teesside University',
    'The Arts University Bournemouth',
    'The City University',
    'The Institute of Cancer Research',
    'The Liverpool Institute for Performing Arts',
    'The Manchester Metropolitan University',
    'The National Film and Television School',
    'The Nottingham Trent University',
    'The Open University',
    "The Queen's University of Belfast",
    'The Robert Gordon University',
    'The Royal Central School of Speech and Drama',
    'The Royal Veterinary College',
    'The School of Oriental and African Studies',
    'The University of Aberdeen',
    'The University of Bath',
    'The University of Birmingham',
    'The University of Bolton',
    'The University of Bradford',
    'The University of Brighton',
    'The University of Bristol',
    'The University of Buckingham',
    'The University of Cambridge',
    'The University of Central Lancashire',
    'The University of Chichester',
    'The University of Dundee',
    'The University of East Anglia',
    'The University of East London',
    'The University of Edinburgh',
    'The University of Essex',
    'The University of Exeter',
    'The University of Glasgow',
    'The University of Greenwich',
    'The University of Huddersfield',
    'The University of Hull',
    'The University of Keele',
    'The University of Kent',
    'The University of Lancaster',
    'The University of Leeds',
    'The University of Leicester',
    'The University of Lincoln',
    'The University of Liverpool',
    'The University of Manchester',
    'The University of Northampton',
    'The University of Oxford',
    'The University of Portsmouth',
    'The University of Reading',
    'The University of Salford',
    'The University of Sheffield',
    'The University of Southampton',
    'The University of St Andrews',
    'The University of Stirling',
    'The University of Strathclyde',
    'The University of Sunderland',
    'The University of Surrey',
    'The University of Sussex',
    'The University of Wales',
    'The University of Warwick',
    'The University of West London',
    'The University of Westminster',
    'The University of Winchester',
    'The University of Wolverhampton',
    'The University of York',
    'The University of the West of Scotland',
    'Trinity Laban Conservatoire of Music and Dance',
    'University Campus Suffolk',
    'University Centre Leeds',
    'University College Birmingham',
    'University College London',
    'University for the Creative Arts',
    'University of Abertay Dundee',
    'University of Bedfordshire',
    'University of Chester',
    'University of Cumbria',
    'University of Derby',
    'University of Durham',
    'University of Gloucestershire',
    'University of Hertfordshire',
    'University of London (Institutes and activities)',
    'University of Newcastle-upon-Tyne',
    'University of Northumbria at Newcastle',
    'University of Nottingham',
    'University of Plymouth',
    'University of South Wales',
    'University of St Mark and St John',
    'Ulster University',
    'University of Wales Trinity Saint David',
    'University of Worcester',
    'University of the Arts, London',
    'University of the Highlands and Islands',
    'University of the West of England, Bristol',
    'Writtle College',
    'York St John University',
];

const universitiesEs = [
    'Advantere School of Management',
    'Afi Escuela de Finanzas',
    'Àrtidi',
    "Aules Escola d'Arts Escèniques a Barcelona",
    'Barcelona Culinary Hub - UB',
    'Barcelona School of Creativity',
    "BAU Centre Universitari d'Arts i Disseny",
    'Business and Language College Spain',
    'C3S Business School',
    'CEI: Centro de Estudios de Innovación - diseño y Marketing',
    'CEIJ Centro de Estudios e Investigaciones Jurídicas',
    'Central Barcelona - Escuela Aeronáutica',
    'Centro De Estudios Financieros CEF',
    'Centro Superior de Diseño de Moda de Madrid (adscrito a la UPM)',
    'CES Don Bosco',
    'CES Villanueva',
    'CESDA - Universitat Rovira i Virgili - Escuela Oficial de Pilotos',
    'CEV - Centre de Comunicació, Imatge i So',
    'CIB - Escuela Culinaria de Barcelona',
    'CIS The college for International Studies',
    'CMI Business School',
    'CUNEF University',
    'Deusto Business School',
    'Digitech FP Madrid (Chamartín)',
    'Digitech FP Madrid (Chamberí)',
    'DMAD Escuela de diseño',
    'EADA Business School',
    'EAE Business School (Joaquín Costa)',
    'EAE Business School (Príncipe Vergara)',
    'EAE Business School',
    'ECIB - Escola de Cinema de Barcelona',
    'Economist & Jurist School (E&J School)',
    'EINA - Centre Universitari de Disseny i Art de Barcelona',
    'El Taller - Escuela de Joyería Barcelona',
    'ELISAVA - Campus de les Arts Can Ricart',
    'Elisava - Design Masters in Madrid',
    'ENEB - Escuela de Negocios Europea de Barcelona',
    'ENTI - UB (Escuela de Nuevas Tecnologías Interactivas)',
    'EOI (Escuela de Organización Industrial)',
    "Eòlia - Centre Superior d'Art Dramàtic",
    'EPITECH - European Institute of Technology',
    'ESADE Business School Madrid (Mirasierra Campus)',
    'ESADE Business School Sant Cugat',
    'ESADE Law School Barcelona',
    "Escola Massana - Centre Municipal d'Art i Disseny",
    'ESCP Business School (Maria de Molina Campus)',
    'ESCP Business School (Puerta de Hierro campus)',
    'Escuela de Arte La Palma',
    'Escuela de Dirección Hotelera Internacional - Vatel Madrid',
    'Escuela de Hostelería Hofmann',
    'Escuela de Organización Industrial',
    'Escuela Superior de Diseño de Madrid (ESDM)',
    'Escuela Universitaria de Profesorado Fomento de Centros de Enseñanza',
    'ESCUNI',
    'ESDEN Business School',
    'ESDIP_Escuela De Arte Sede',
    'ESEI International Business School',
    'ESERP - The Barcelona School of Business and Social Science',
    'ESERP Business School',
    "ESHOB Escola Superior d'Hostaleria de Barcelona",
    'ESIC Business & Marketing School - Madrid',
    'ESIC University',
    'ESMUC (Escola Superior de Música de Catalunya)',
    'ETJ Law & Business School (Escuela de Técnica Jurídica)',
    'EUDE European Business School',
    'EUM - UdG (Escola Universitària del Mediterrani)',
    'European Open Business School',
    'European Sport Business School - AMOS',
    'European University (EU) Business School',
    'Fashion Law Institute Spain FLIS',
    'FX Animation Barcelona 3D & Film School',
    'GBS - Geneva Business School',
    'GBSB Global Business School | Madrid Campus',
    'Geneva Business School - Madrid Campus',
    'Global Fashion & Luxury Management - EIDM',
    'IAAC | Fab Lab Barcelona',
    'IE University (IE Tower)',
    'IE University (Maria de Molina Campus)',
    'IEB - Instituto de Estudios Bursátiles',
    'IED - Istituto Europeo Di Design Barcelona',
    'IED Madrid (Istituto Europeo di Design)',
    'IED Madrid (Istituto Europeo di Design) - Carabanchel',
    'IESE Business School (Universitat de Navarra)',
    'IESE Business School',
    'IM Digital Business School',
    'INESDI Business Techschool',
    'INSA Barcelona - Business, Marketing and Communication School',
    'International American University Madrid',
    'International Hospitality and Luxury Brand Management by CMH',
    'Ipac Bachelor Factory',
    'IQS School of Engineering',
    'IQS School of Management',
    'ISBIF Finance School',
    'ISDE - Higher Institute of Law and Economics',
    'ISDE - Instituto Superior de Derecho y Economía',
    'ISDI - The Digital Business School',
    'ISDI Education',
    'ISEP Barcelona (Instituto Superior de Estudios Psicológicos)',
    'IUNIT Centro Internacional Universitario de Negocio, Innovación y Tecnología - centro adscrito a URJC',
    "L'Idem Creative Arts School",
    'La Salle - Escuela Técnica Superior de Arquitectura',
    'La Salle - Facultad Internacional de Comercio y Economía Digital',
    'La Salle - Otras',
    'La Salle - URL - Escuela Técnica Superior de Ingeniería',
    'La Universidad Internacional de la Empresa (UNIE)',
    'LCI Barcelona - Escuela Superior de Diseño',
    'Le Cordon Bleu Madrid',
    'Makkers School',
    'Miami Ad School Madrid - Escuela de publicidad y creatividad',
    'MIOTI Tech & Business School',
    'MOM Culinary Institute',
    'MPG European Health School',
    'NBS - Neuroscience Business School',
    'Nuclio Digital School',
    'Nuclio Digital School',
    'Otros',
    'Real Centro Universitario Escorial María Cristina - Adscrito a CEU San Pablo',
    'Sagardoy Business & Law School',
    'Saint Louis University - Madrid',
    'Sant Joan de Déu Campus Docente - UB',
    'SBS Swiss Business School Barcelona Campus',
    'SBS Swiss Business School Madrid Campus',
    'Schiller International University',
    'Scouting Model Academy',
    'Spain Business School',
    'Suffolk University Boston',
    'SUR Escuela de Arte y Profesiones Artísticas',
    'TAI School of the Arts',
    'TBS - Toulouse Business School',
    'The Norman Foster Institute (NFI)',
    'The Valley Digital Business School',
    'UAB - Escola Universitària d\'Infermeria i de Fisioteràpia "Gimbernat"',
    'UAB - Escola Universitària d\'Informàtica "Tomàs Cerdà"',
    "UAB - Escola Universitària d'Infermeria i Teràpia Ocupacional",
    'UAB - Escuela Universitaria de Enfermería UAB - Campus Sant Pau',
    'UAB - EUSS School of Engineering (Escola Universitària Salesiana de Sarrià)',
    'UAB - Facultad de Medicina de la UAB - Campus Sant Pau',
    'UAB - Institut Guttmann',
    'UAB - Otras',
    "UAB - Vall d'Hebron Institut de Recerca (VHIR)",
    'UB - Barcelona School of Tourism, Hospitality and Gastronomy (CETT)',
    'UB - Centro Universitario Internacional de Barcelona (UNIBA)',
    'UB - Escuela Superior de Cine y Audiovisuales de Cataluña (ESCAC)',
    'UB - Escuela Superior de Comercio y Distribución (ESCODI)',
    'UB - Escuela Superior de Relaciones Públicas (ESRP)',
    'UB - Escuela Universitaria de Enfermería Sant Joan de Déu',
    'UB - Facultat de Belles Arts - Campus Diagonal Sud',
    'UB - Facultat de Biologia - Campus Diagonal Sud',
    'UB - Facultat de Ciències de la Terra - Campus Diagonal Sud',
    'UB - Facultat de Dret - Campus Diagonal Nord',
    "UB - Facultat de Farmàcia i Ciències de l'Alimentació - Campus de la Alimentación de Torribera",
    "UB - Facultat de Farmàcia i Ciències de l'Alimentació - Campus Diagonal",
    'UB - Facultat de Filologia i Comunicació',
    'UB - Facultat de Filosofia',
    'UB - Facultat de Física',
    'UB - Facultat de Geografia i Història',
    'UB - Facultat de Matemàtiques i Informàtica',
    'UB - Facultat de Medicina i Ciències de la Salut - Campus de Ciencias de la Salud de Bellvitge (Enfermeria, Odontologia)',
    'UB - Facultat de Medicina i Ciències de la Salut - Campus de Medicina - Clínic August Pi i Sunyer',
    'UB - Facultat de Psicologia - Campus Mundet',
    "UB - Facultat d'Economia i Empresa - Campus Diagonal Nord",
    "UB - Facultat d'Educació - Campus Mundet",
    "UB - Facultat d'Informació i Mitjans Audiovisuals",
    'UB - Institut de Formació contínua IL3',
    'UB - Instituto de Seguridad Pública de Cataluña (ISPC)',
    'UB - Instituto Nacional de Educación Física de Cataluña (INEFC)',
    'UB - Otras',
    'UCM - Escuela de Práctica Juridica',
    'UIBS - United International Business School',
    'UIC - Campus salud - Medicina, Enfermería, Fisioterapia, Odontología (Sant Cugat)',
    'UIC - Derecho, Arquitectura, Comunicación, Humanidades, Magisterio (Barcelona)',
    'United International Business School (UIBS)',
    'Universidad Alfonso X El Sabio (UAX) (Campus Chamberí)',
    'Universidad Alfonso X El Sabio (UAX) (Campus Villanueva)',
    'Universidad Antonio de Nebrija (Arturo Soria)',
    'Universidad Antonio de Nebrija (Instituto Nebrija de FP - Edificio Joaquín María López)',
    'Universidad Antonio de Nebrija (La Berzosa)',
    'Universidad Antonio de Nebrija (Princesa Campus)',
    'Universidad Antonio de Nebrija (San Francisco de Sales Campus)',
    'Universidad Autónoma de Madrid - Enfermería Fundación Jiménez Díaz',
    'Universidad Autónoma de Madrid - Escuela Universitaria de Fisioterapia ONCE',
    'Universidad Autónoma de Madrid - La Salle Centro Universitario',
    'Universidad Autónoma de Madrid (Cantoblanco Campus)',
    'Universidad Autónoma de Madrid (Medicina campus)',
    'Universidad Autónoma de Madrid- Escuela Universitaria de Enfermería de Cruz Roja',
    'Universidad Blanquerna - Facultad de Comunicación y Relaciones Internacionales',
    'Universidad Blanquerna - Facultat de Ciències de la Salut Blanquerna-URL',
    "Universidad Blanquerna - Facultat de Psicologia, Ciències de l'Educació i de l'Esport Blanquerna-URL",
    'Universidad Blanquerna - Otras',
    'Universidad Camilo José Cela - HM Montepríncipe CUHMED',
    'Universidad Camilo José Cela - UCJC  (Getafe campus)',
    'Universidad Camilo José Cela - UCJC  (Leganés campus)',
    'Universidad Camilo José Cela - UCJC (Almagro campus)',
    'Universidad Camilo José Cela - UCJC (Castellana campus)',
    'Universidad Camilo José Cela - UCJC (Villafranca campus)',
    'Universidad Carlos III de Madrid (UC3M) (Campus de Colmenarejo)',
    'Universidad Carlos III de Madrid (UC3M) (Campus de Getafe)',
    'Universidad Carlos III de Madrid (UC3M) (Campus de Leganés)',
    'Universidad Carlos III de Madrid (UC3M) (Puerta de Toledo Campus)',
    'Universidad Complutense | NticMaster',
    'Universidad Complutense de Madrid - CES Cardenal Cisneros',
    'Universidad Complutense de Madrid (Chamberí campus)',
    'Universidad Complutense de Madrid (Moncloa campus)',
    'Universidad Complutense de Madrid (Somosaguas campus)',
    'Universidad Europea de Madrid (campus Alcobendas)',
    'Universidad Europea de Madrid (campus Madrid centro)',
    'Universidad Europea de Madrid (campus Villaviciosa de Odón)',
    'Universidad Francisco de Vitoria (UFV) (campus Pozuelo de Alarcón)',
    'Universidad Francisco Marroquín',
    'Universidad Internacional Menéndez Pelayo (campus Ciudad Universitaria)',
    'Universidad Politécnica Madrid (campus Ciudad Universitaria)',
    'Universidad Politécnica Madrid (campus Madrid ciudad)',
    'Universidad Politécnica Madrid (Campus Montegancedo)',
    'Universidad Politécnica Madrid (campus sur)',
    'Universidad Pontificia de Comillas - Escuela Universitaria de Ingeniería Técnica Agrícola (INEA)',
    'Universidad Pontificia de Comillas - ICADE, ICAI, CIHS y otros (Alberto Aguilera, 23 and 25)',
    'Universidad Pontificia de Comillas (campus Cantoblanco)',
    'Universidad Pontificia de Comillas (sede Rey Francisco)',
    'Universidad Pontificia de Comillas -Escuela Universitaria de Enfermería y Fisioterapia “San Juan de Dios”',
    'Universidad Rey Juan Carlos - URJC  (campus Madrid)',
    'Universidad Rey Juan Carlos - URJC (Campus Aranjuez)',
    'Universidad Rey Juan Carlos - URJC (Campus Móstoles)',
    'Universidad Rey Juan Carlos - URJC (Hospital Universitario de Móstoles)',
    'Universidad Rey Juan Carlos - URJC (Hospital Universitario Fundación Alcorcón)',
    'Universidad Rey Juan Carlos - URJC (Hospital Universitario Rey Juan Carlos)',
    'Universidad Rey Juan Carlos - URJC (Madrid - Manuel Becerra)',
    'Universidad Rey Juan Carlos - URJC (Madrid - Quintana)',
    'Universidad Rey Juan Carlos- URJC (Campus Fuenlabrada)',
    'Universidad Rey Juan Carlos- URJC (Hospital Universitario de Fuenlabrada)',
    'Universidad San Pablo CEU (campus de creatividd)',
    'Universidad San Pablo CEU (campus Moncloa)',
    'Universidad San Pablo CEU (campus Montepríncipe)',
    'Universidad Villanueva (Edificio A)',
    'Universidad Villanueva (Edificio B)',
    'Universidad Villanueva (Edificio C)',
    'Universitat Abat Oliba CEU - Facultad de Comunicación, Educación y Humanidades',
    'Universitat Abat Oliba CEU - Facultad de Derecho y Empresa',
    'Universitat Abat Oliba CEU - Facultad de Psicología',
    'Universitat Abat Oliba CEU - Instituto de Ciencias de la Salud',
    'Universitat Abat Oliba CEU - Otras',
    'UPC - Campus Castelldefels',
    'UPC - Centre de la Imatge i la Tecnologia Multimèdia /Tech Talent Center - Campus Terrassa',
    "UPC - Escola d'Enginyeria Agroalimentària i de Biosistemes de Barcelona",
    "UPC - Escola d'Enginyeria de Barcelona Est (EEBE) - Campus Diagonal-Besòs",
    "UPC - Escola d'Enginyeria de Telecomunicacions i Aeroespacial - Campus Diagonal Nord",
    "UPC - Escola Politècnica Superior d'Edificació de Barcelona - Campus Diagonal Sud",
    "UPC - Escola Tècnica Superior d'Enginyeria Industrial de Barcelona - Campus Diagonal Sud",
    "UPC - Escola Tècnica Superior d'Enginyeria Industrial de Barcelona (ETSEIB) Campus Diagonal-Besòs",
    "UPC - Escola Tècnica Superior d'Enginyers de Camins, Canals i Ports - Campus Diagonal Nord",
    "UPC - Escola Universitària d'Enginyeria Tècnica Industrial de Barcelona (EUETIB) Campus Diagonal-Besòs",
    'UPC - Facultat de Matemàtiques i Estadística - Campus Diagonal Sud',
    'UPC - Facultat de Nàutica de Barcelona (FNB) - Campus Barceloneta',
    "UPC - Facultat d'Informàtica de Barcelona (FIB) - Campus Diagonal Nord",
    'UPC - Institut de Bioenginyeria de Catalunya (IBC) - Campus Diagonal-Besòs',
    'UPC - Otras',
    'UPF - Barcelona School of Economics (BSE) - Campus Ciutadella',
    'UPF - Barcelona School of Management (BSM) - Edificio Balmes',
    'UPF - Escola Superior de Comerç Internacional (ESCI)',
    'UPF - Escuela de Ingeniería - Campus Poblenou',
    'UPF - Escuela Superior de Enfermería del Mar (ESIMar) - Campus Mar',
    'UPF - Facultad de Ciencias de la Salud y de la Vida - Campus Mar',
    'UPF - Facultad de Ciencias Económicas y Empresariales - Campus Ciutadella',
    'UPF - Facultad de Ciencias Políticas y Sociales - Campus Ciutadella',
    'UPF - Facultad de Comunicación - Campus Poblenou',
    'UPF - Facultad de Derecho - Campus Ciutadella',
    'UPF - Facultad de Humanidades - Campus Ciutadella',
    'UPF - Facultad de Traducción y Ciencias del Lenguaje - Campus Poblenou',
    'UPF - Otras',
    'URL - Escuela Superior de Diseño (ESDi)',
    'URL - Facultad de Filosofía',
    "URL - Facultat d'Educació Social i Treball Social Pere Tarrés",
    'URL - Institut Borja de Bioètica',
    'URL - Instituto Universitario de Salud Mental Vidal i Barraquer',
    'URL - Otras',
    'U-tad | Centro Universitario de Tecnología y Arte Digital',
    'VATEL - Hotel & Tourism Business School',
    'Voxel School University Center for Digital Arts',
];

type CountryCode = 'en' | 'es';

export const universitiesCountryMap: Record<CountryCode, string[]> = {
    en: universitiesEn,
    es: universitiesEs,
};

export const residency = [
    { value: locales.confirmation_yes, label: 'confirmation_yes' },
    { value: locales.confirmation_no, label: 'confirmation_no' },
];

export const nieNifMaxLength = 11;
